module.exports = __webpack_public_path__ + "img/11.24f5e3f7.png";